const orderingProcess = {
  heading: 'Medikamente einfach und sicher auf IhreApotheken bestellen',
  selectiveBlock: {
    heading: 'Medikamente schnell erhalten',
    paragraph: 'Bestellen Sie Medikamente direkt bei uns vor und profitieren Sie von der hohen Verfügbarkeit unseres Sortiments. Sie erhalten Ihre Bestellung in der Regel innerhalb weniger Stunden.',
  },
  tiles: {
    1: 'Medikamente bestellen und (E-)Rezepte einlösen',
    2: 'Lieferart auswählen',
    3: 'Zahlungsart auswählen',
    4: 'Bestellung abholen oder per Botendienst erhalten',
  },
}

export default orderingProcess
